module.exports = __webpack_public_path__ + "static/media/Group76-1200.b994b1e4.webp";